import axios from "axios";
import { config } from "./Setting";

const APIClient = axios.create({
  baseURL: config.baseUrl,
});

export default APIClient;
